/**
 * Discount data model per item: { id, amount, type: 'percent', createdAt, enabled, ...when }
 * "when" is nothing (indefinite), startDate + endDate, or schedule
 * ({type:'days_of_week', days} | {type:'yearly_month', month} | {type:'yearly_range', ...}).
 * Resolution: sort by createdAt asc, filter to currently active, last wins.
 */
function isScheduleActive(schedule, now) {
  const dow = now.getDay()
  const month = now.getMonth() + 1
  const day = now.getDate()

  if (schedule.type === "days_of_week") return (schedule.days || []).includes(dow)
  if (schedule.type === "yearly_month") return month === schedule.month
  if (schedule.type === "yearly_range") {
    const { startMonth, startDay, endMonth, endDay } = schedule
    const nowNum = month * 100 + day
    const startNum = startMonth * 100 + startDay
    const endNum = endMonth * 100 + endDay
    if (startNum <= endNum) return nowNum >= startNum && nowNum <= endNum
    return nowNum >= startNum || nowNum <= endNum
  }
  return false
}

function isDiscountActive(discount, now) {
  const hasDateRange = discount.startDate !== undefined || discount.endDate !== undefined
  const hasSchedule = !!discount.schedule
  if (!hasDateRange && !hasSchedule) return true

  if (hasDateRange) {
    const start = discount.startDate ? new Date(discount.startDate) : null
    const end = discount.endDate ? new Date(discount.endDate + "T23:59:59") : null
    if (start && now < start) return false
    if (end && now > end) return false
    return true
  }
  return isScheduleActive(discount.schedule, now)
}

function computeActiveDiscount(discounts) {
  if (!discounts?.length) return null
  const now = new Date()
  const sorted = [...discounts].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
  const active = sorted.filter((d) => d.enabled !== false && isDiscountActive(d, now))
  return active[active.length - 1] || null
}

export function applyDiscount(cost, discountPercent) {
  if (!discountPercent || discountPercent <= 0) return cost
  return Math.round(cost * (1 - discountPercent / 100))
}

export const activeDiscountPercent = (product) =>
  computeActiveDiscount(product?.discounts)?.amount || 0
